<nz-spin *ngIf="isLoading; else resultTpl" nzSimple></nz-spin>

<ng-template #resultTpl>
  <em-error-result
    *ngIf="errorMessage; else longTextTpl"
    [subTitle]="errorMessage"
  ></em-error-result>
</ng-template>

<ng-template #longTextTpl>
  <pre *ngIf="longText; else noDataTpl">{{ longText }}</pre>
</ng-template>

<ng-template #noDataTpl>
  <nz-empty nzNotFoundContent="No long text"></nz-empty>
</ng-template>
